import { useCallback, useEffect, useState } from "react";
import Main from "./Main";
import { LearningScreen } from "./features/learning/learning_screen";

export function PortalApp() {
  const isLearning = () =>
    /^#(?:tests|build|variants|bank|statistics|profile|results|attempt\/)/.test(
      window.location.hash,
    );
  const [learning, setLearning] = useState(isLearning);
  const leave = useCallback(() => setLearning(false), []);
  useEffect(() => {
    const change = () => {
      if (
        /^#(?:tests|build|variants|bank|statistics|profile|results|attempt\/)/.test(
          window.location.hash,
        )
      )
        setLearning(true);
    };
    window.addEventListener("hashchange", change);
    return () => window.removeEventListener("hashchange", change);
  }, []);
  return learning ? <LearningScreen onLeave={leave} /> : <Main />;
}
